import React, { FC, useState } from "react";
import { FaTrash } from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaCirclePlus, FaMagnifyingGlass } from "react-icons/fa6";
import { useSearchAssociationApiQuery } from "../../../hoa/association/associationApi";
import ModalButton from "../../../../components/common/form/ModalButton";
import CommonSelectorModal from "../../../../components/common/form/CommonSelectorModal";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { useCreateSubdivisionAssociationMutation, useDeleteSubdivisionAssociationMutation } from "../subDivisionApi";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";

type SubdivisionDetailInfoProps = {
    subdivisionData: any;
};


const Associations: FC<SubdivisionDetailInfoProps> = ({ subdivisionData }) => {
    const { subdivisionId } = useParams();
    const [deleteApi, { isLoading }] = useDeleteSubdivisionAssociationMutation();
    const [selectedRow, setSelectedRow] = useState<any>({});
    const [showAddModal, setShowAddModal] = useState(false);
    const [createApi, createApiRes] = useCreateSubdivisionAssociationMutation();

    const customerFilter = {
        "state": subdivisionData?.county?.state?.stateAbbreviation,
        "county": subdivisionData?.county?.id,
        "sort": "creationDate",
        "sortOrder": "DESCENDING"

    }
    const moduleNameColumns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "name",
            filterOptions: [{
                filterModalOption: {
                    filterModalPlaceHolder: "Enter Name...",
                    filterModalKey: "name",
                    filterModalIcon: <FaMagnifyingGlass size={14} className={''} />
                },
                overrideFilterLabel: " ",
                overrideFilterAccessor: "name"
            }],
        },
        {
            label: "County",
            accessor: "county.countyName",
        }
    ]


    const handleAssociationSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (subdivisionId) {
            await createApi({
                associationsId: selectedRow?.id,
                subdivisionId: subdivisionId,
            });
            setShowAddModal(false);
        }
    };

    const handleDelete = (id: any) => {
        deleteApi({
            "associationId": id,
            "subdivisionId": subdivisionId
        });
    }

    return (
        <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm mt-3 rounded-md">
            <div className="flex justify-between items-center  border-b border-[rgba(0,0,0,0.1)] p-2">
                <h5 className="font-semibold text-surface-0">Associations

                    ({subdivisionData?.associations.length || 0})</h5>
                {hasPermission(['SUBD-U']) &&
                    <FaCirclePlus onClick={() => setShowAddModal(true)} className={"text-highlight-0"}/>
                }


            </div>
            <div className="p-2 max-h-[150px] overflow-auto scrollbar-hide">
                <table className="w-full bg-text-0 border-b border-[rgba(0,0,0,0.1)] border">
                    <thead className="border-b-2 border-[rgba(0,0,0,0.1)]">
                        <tr>
                            {["Name", "County", ...(hasPermission(["SUBD-U"]) ? ["Action"] : [])].map((heading) => (
                                <th key={heading} className="text-left whitespace-nowrap">{heading}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {subdivisionData?.associations?.length === 0 ? (
                            <tr>
                                <td colSpan={13} className="p-2">
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            subdivisionData?.associations.map((data: any) => (
                                <tr key={data.id} className="bg-text-1">
                                    <td className="p-2">
                                        {hasPermission(["ASSOC-R"]) ? (
                                            <Link to={`/associations/${data.id}`} className="text-[#007bff]">
                                                {data.name || "-"}
                                            </Link>
                                        ) : (
                                            <span>{data?.name || "-"}</span>
                                        )}

                                    </td>
                                    <td className="p-2">{data.county?.countyName || "-"}</td>
                                    <td className="px-4 py-2">
                                        {hasPermission(["SUBD-U"]) &&
                                            <ModalButton
                                                triggerButton={<FaTrash title="Delete Association" className={"text-highlight-0"}/>}
                                                modal={
                                                    <ConfirmationModal
                                                        show={true}
                                                        setShow={() => { }}
                                                        title="Delete Association"
                                                        bodyMessage="Are you sure you want to delete this Association?"
                                                        onSubmit={() => handleDelete(data.id)}
                                                        isLoading={isLoading}
                                                    />
                                                }
                                            />}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>

                </table>
            </div>
            {showAddModal &&
                <CommonSelectorModal
                    title="Association Selector"
                    columns={moduleNameColumns}
                    data={useSearchAssociationApiQuery}
                    show={showAddModal}
                    onSubmit={handleAssociationSubmit}
                    setSelectedRow={setSelectedRow}
                    customerFilter={customerFilter}
                    setShow={setShowAddModal}
                    isLoading={createApiRes.isLoading}
                />
            }
        </div>

    );
};

export default Associations;
